import styled from 'styled-components'
import { color } from '@configs/utilities'

const ForItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const TextInputWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 15px 0;

  label {
    color: ${color.white};
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 10px;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 300px;
  margin: 40px auto 0;

  button {
    font-size: 18px;
    font-weight: 500;
    border: none;

    &:disabled,
    &[data-disabled] {
      border: none;
      background-color: #f4d991;
      color: ${color.white};
    }
  }
`

const ButtonIcon = styled.img`
  width: 20px;
`

export { ForItemsWrapper, TextInputWrapper, ButtonWrapper, ButtonIcon }
